"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement } from "react";
import ChevronDownIcon from "./chevron-down.js";
import ChevronUpIcon from "./chevron-up.js";
export function SelectIcon(_a) {
    var { open } = _a, props = __rest(_a, ["open"]);
    return createElement(open ? ChevronUpIcon : ChevronDownIcon, props);
}
export default SelectIcon;
//# sourceMappingURL=select-icon.js.map